// @flow
import React from 'react';
import type { Blend as BlendType } from '../../blend/types';

// Blend
import BlendItem from './BlendItem';

// Style
import './BlendList.css';

type Props = {
  blends: BlendType[],
  handleRemoveBlend: (lineItemId: number) => void,
  loading?: boolean,
};

function BlendList({ blends, handleRemoveBlend, firstBlendItemById, loading = false }: Props) {
  return (
    <div className="blend-list-main">
      {blends.map((blend) => (
        <BlendItem
          key={blend.id}
          item={blend}
          variant={blend.lineItems[0]?.variant}
          productId={blend.id}
          handleRemoveBlend={handleRemoveBlend}
          loading={loading}
        />
      ))}
    </div>
  );
}

export default BlendList;
